export const MAINTAINED_BY_RELATION = 'maintainedBy';
export const MAINTAINER_OF_RELATION = 'maintainerOf';
